import React from 'react';
import { FormControl, FormHelperText, FormLabel, OutlinedInput } from "@mui/material";

interface FormTextFieldProps {
    label: string;
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    helperText?: string;
    multiline?: boolean;
    rows?: number;
    type?: string;
}

const FormTextField = (props: FormTextFieldProps) => {
    return (
        <FormControl fullWidth>
            <FormLabel>{props.label}</FormLabel>
            <OutlinedInput
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                placeholder={props.placeholder}
                error={props.error}
                multiline={props.multiline}
                rows={props.rows}
                type={props.type ?? "text"}
            />
            {props.error && props.helperText && (
                <FormHelperText error>{props.helperText}</FormHelperText>
            )}
        </FormControl>
    );
};

export default FormTextField;
